import { DocInvoice, InvoiceData, UploadedLedgerRecord } from '../api/types';

type VendorResolutionLike = {
    clean_vendor_name?: string;
    raw_vendor_name?: string;
};

const cleanText = (value: unknown): string => String(value || '').trim();

export const getInvoiceDataVendorName = (
    data?: Partial<InvoiceData> | null,
    fallback?: string | null,
): string => {
    const vendorResolution = (data?.metadata?.vendor_resolution || {}) as VendorResolutionLike;
    return cleanText(
        vendorResolution.clean_vendor_name
        || data?.vendor?.resolved_name
        || data?.vendor?.name
        || vendorResolution.raw_vendor_name
        || fallback
        || '',
    );
};

export const getDocumentVendorName = (
    record?: Partial<DocInvoice> | Partial<UploadedLedgerRecord> | null,
    fallback?: string | null,
): string => {
    const preferredDataName = getInvoiceDataVendorName(record?.data as Partial<InvoiceData> | undefined);
    if (preferredDataName) return preferredDataName;

    const originalParsedName = getInvoiceDataVendorName(record?.original_parsed_data as Partial<InvoiceData> | undefined);
    if (originalParsedName) return originalParsedName;

    return cleanText(fallback || '');
};
